import React from "react";
import TitleWithSwiper from "@components/swiper/TitleWithSwiper";
import HomeBrandCard from "@components/card/HomeBrandCard";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const BrandSwiperItem = styled(SwiperSlide)({
  display: "flex",
  flexGrow: 1,
  minWidth: "250px",
  maxWidth: "520px",
  cursor: "pointer",
});

const BrandSwiper = () => {
  const lang = window.localStorage.getItem("language");

  const { getBrandExploreList } = useApiRequest();

  const { data: brandExploreList, isLoading } = useQuery({
    queryKey: ["brandExploreList"],
    queryFn: getBrandExploreList,
  });

  return (
    <TitleWithSwiper
      title="도매 브랜드 탐험"
      route="/search?tab=brand"
      preview={2}
      space={0}>
      {brandExploreList?.map((item: any) => (
        <BrandSwiperItem key={item.brand_explore_id}>
          <HomeBrandCard
            title={lang === "en" ? item.brand_name_en : item.brand_name_ko}
            desc={lang === "en" ? item.introduction_en : item.introduction_ko}
            src={item.thumbnail_url}
            id={item.brand_id}
          />
        </BrandSwiperItem>
      ))}
    </TitleWithSwiper>
  );
};

export default BrandSwiper;
